import { useState } from 'react';

import {
  HookSort,
  SortDirection,
  SortType,
} from '../components/NewStrategy/types';

export const useSort = (
  arr: SortType[],
  initialType?: string,
  initialDirection?: SortDirection
) => {
  const [{ direction, type }, setSort] = useState<HookSort>({
    direction: initialDirection ?? 'sortUp',
    type: initialType ?? arr[0],
  });

  /**
   *
   * @param type SortType
   * @param direction 'sortDown' | 'sortUp'
   * @returns void
   */
  const handleSort = (type: SortType, direction: SortDirection) => {
    setSort({ direction, type });
  };

  const getSortValue = (
    a: number | string | undefined | null,
    b: number | string | undefined | null
  ) => {
    direction !== 'sortUp' && ([a, b] = [b, a]);

    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b)
      : typeof a === 'number' && typeof b === 'number'
      ? a - b
      : 0;
  };

  return { direction, type, getSortValue, handleSort };
};
